/**
 * Pure domain logic for Device Faceplate 2D rendering and status computation.
 */

export function getChassisClass(name?: string | null, manufacturer?: string | null): string {
  // ponytail: substring vendor heuristics ceiling; upgrade to structured equipment catalog profile when available
  const combined = `${name || ''} ${manufacturer || ''}`.toLowerCase();
  if (combined.includes('cisco')) return 'faceplate-chassis-cisco';
  if (combined.includes('dell')) return 'faceplate-chassis-dell';
  if (combined.includes('huawei')) return 'faceplate-chassis-huawei';
  return 'faceplate-chassis-default';
}

export function isPortConnected(
  portId: string,
  cables: Array<{ port_a_id: string; port_b_id: string }> = []
): boolean {
  if (!portId || !Array.isArray(cables)) return false;
  return cables.some(c => String(c.port_a_id) === String(portId) || String(c.port_b_id) === String(portId));
}

export interface CableEndpointInfo {
  cable_id?: string;
  cable_type?: string;
  dest_equipment_id?: string;
  dest_equipment_name?: string;
  dest_port_name?: string;
}

export function resolveLocalCableEndpoint(
  portId: string,
  cables: Array<{ id?: string; port_a_id: string; port_b_id: string; cable_type?: string }> = [],
  allEquipment: Array<{ id: string | number; name: string; ports?: Array<{ id: string | number; name: string }> }> = []
): CableEndpointInfo | null {
  if (!portId || !Array.isArray(cables)) return null;

  const cable = cables.find(c => String(c.port_a_id) === String(portId) || String(c.port_b_id) === String(portId));
  if (!cable) return null;

  const otherPortId = String(cable.port_a_id) === String(portId) ? String(cable.port_b_id) : String(cable.port_a_id);

  let destEquipmentName = 'Оборудование подключено';
  let destPortName = 'Активный линк';
  let destEquipmentId: string | undefined = undefined;

  if (Array.isArray(allEquipment)) {
    for (const eq of allEquipment) {
      const matchedPort = eq.ports?.find(p => String(p.id) === otherPortId);
      if (matchedPort) {
        destEquipmentId = String(eq.id);
        destEquipmentName = eq.name;
        destPortName = matchedPort.name;
        break;
      }
    }
  }

  return {
    cable_id: cable.id,
    cable_type: cable.cable_type || 'Cat6 Patch Cord',
    dest_equipment_id: destEquipmentId,
    dest_equipment_name: destEquipmentName,
    dest_port_name: destPortName,
  };
}

export const EQUIPMENT_TYPE_LABELS_RU: Record<string, string> = {
  server: 'СЕРВЕР',
  switch: 'КОММУТАТОР',
  router: 'МАРШРУТИЗАТОР',
  patch_panel: 'ПАТЧ-ПАНЕЛЬ',
  storage: 'СХД',
  firewall: 'ФАЙРВОЛ',
  pdu: 'PDU',
  ups: 'ИБП',
};

export function formatEquipmentTypeLabel(type?: string | null): string {
  if (!type) return 'ОБОРУДОВАНИЕ';
  const normalized = type.toLowerCase();
  return EQUIPMENT_TYPE_LABELS_RU[normalized] || type.toUpperCase();
}
